<div theme>
  <dxc-select
    label="{{label | translate}}"
    margin="margin"
    [options]="autoOptions"
    (onChange)="onChange($event)"
    (onBlur)="onBlur($event)"
    size="size"
    [value]="value" 
    [searchable]="true"
    [placeholder]="placeholdername"
    [error]="errorMessage"
    [disabled]="disabled"
    [class.required]="required"
    [class]="applyclass"
  >
  </dxc-select>
</div>
